import { useMediaQuery } from '@chakra-ui/react';

export function useIsTouchDevice() {
  const [isTouchDevice] = useMediaQuery(
    '(pointer: coarse), (any-pointer: coarse)'
  );

  return isTouchDevice;
}
